export default __webpack_public_path__ + "static/media/true-false-blue.6b1232dd.svg";